import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDMarkCustomsNotificationAsReadData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useMarkTSDCustomsNotificationAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TSDMarkCustomsNotificationAsReadData) => {
      const result = await apiClient.tsd.markCustomsNotificationAsRead.mutation({ params: data });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storage', data.id] });
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Notification marked read.');
    },
    onError: (error) => {
      showErrorToast(error, `Error marking the notification as read!`);
    },
  });
};
